import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './material.css'
import './../../css/nike.css'
import Sofive from './../../images/sofive.png'
import Scoreplay from './../../images/scoreplay.png'

const vsImage = require('./../../images/vssmall.png')

class Details extends Component {
  render() {
    return (
      <div>
        <div className="row valign-wrapper" style={{ height: '40vh' }}>
          <div
              className="col s12 center-align home txt"
              style={{ fontSize: '18vh', lineHeight: 1 }}
            >
              {this.props.home}
            </div>
        </div>
          <div
            className="row"
            style={{
              height: '20vh',
            }}
          >
          <div
              className="col s12 center-align txt"
              style={{ fontSize: '18vh', lineHeight: 1 }}
            >
              VS
            </div>
          </div>
        <div className="row valign-wrapper" style={{ height: '40vh' }}>
          <div
              className="col s12 center-align away txt"
              style={{ fontSize: '18vh', lineHeight: 1 }}
            >
              {this.props.away}
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Details)
)
